const apiBaseUrl = import.meta.env.VITE_SIELPA_PLUS_API_BASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
const CLIENT_ID_KEY = "sielpa-plus:client-id:v1";

export const PREMIUM_TTS_MAX_CHARS = 500;

let memoryClientId = "";

export function isPremiumTtsConfigured() {
  return Boolean(apiBaseUrl && anonKey);
}

export function getPremiumTtsClientId() {
  try {
    const existing = window.localStorage.getItem(CLIENT_ID_KEY);
    if (existing) return existing;

    const id = window.crypto && typeof window.crypto.randomUUID === "function"
      ? window.crypto.randomUUID()
      : `anon-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;

    window.localStorage.setItem(CLIENT_ID_KEY, id);
    return id;
  } catch {
    if (!memoryClientId) {
      memoryClientId = `anon-memory-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
    }
    return memoryClientId;
  }
}

export async function generatePremiumTts(payload) {
  if (!isPremiumTtsConfigured()) {
    throw new Error("Premium Voice is not configured. Add VITE_SIELPA_PLUS_API_BASE_URL and VITE_SUPABASE_ANON_KEY.");
  }

  const response = await fetch(`${apiBaseUrl.replace(/\/$/, "")}/generate-premium-tts`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${anonKey}`,
      apikey: anonKey,
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      app: "sielpa",
      clientId: getPremiumTtsClientId(),
      ...payload
    })
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok || !data.ok) {
    const error = new Error(data.message || "Premium Voice request failed.");
    error.code = data.code || "request_failed";
    error.data = data;
    throw error;
  }
  return data;
}
